import React from 'react';
import trophyGold from '@/assets/img/tropy-gold_01.png';

interface TrohyBadgeCardProps {
  type?: 'trophy' | 'badge';
  showLabel?: boolean;
  iconUrl?: string;
  name?: string;
  description?: string;
  date?: string;
  count?: number; // 획득 횟수
}

const TrohyBadgeCard: React.FC<TrohyBadgeCardProps> = ({ 
  type = 'trophy',
  showLabel = true, 
  iconUrl,
  name = '라벨',
  description,
  date = '2025-01-01',
  count = 1
}) => {
  return (
    <div className='flex flex-col gap-4 justify-center items-center'>
        <div className='relative flex items-center justify-center size-[100px] p-6 bg-gray-50 rounded-full'>
            <img 
              src={iconUrl || trophyGold} 
              alt="trophy-badge-card" 
              className='w-full object-contain' 
            />
            {count > 1 && (
              <div className='absolute -top-1 -right-1 flex items-center justify-center min-w-[28px] h-[28px] px-2 bg-orange-500 text-white text-xs font-bold rounded-full shadow-md'>
                x{count}
              </div>
            )}
        </div>
        {showLabel && (
          <div className='flex flex-col justify-center items-center'>
              <p className='font-black'>{name}</p>
              <p className='text-sm text-gray-400'>{date}</p>
          </div>
        )}
    </div>
  );
};

export default TrohyBadgeCard;